// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".App {\n  height: 100%;\n}\n\n.Cboard__FontSize__Standard {\n  font-size: 14px;\n}\n\n.Cboard__FontSize__Large {\n  font-size: 18px;\n}\n\n.Cboard__FontSize__ExtraLarge {\n  font-size: 22px;\n}\n", ""]);
// Exports
module.exports = exports;
